import {createAction} from 'redux-actions'

export const fetch = createAction('ROLES/PERMISSIONS/FETCH', roleId => roleId)
export const receive = createAction('ROLES/PERMISSIONS/RECEIVE', null, (_, roleId) => ({roleId}))